import request from '@/utils/request';

export function get(url, params = {}) {
  return request({
    url,
    method: 'get',
    params
  });
}

export function post(url, data) {
  return request({
    url,
    method: 'get',
    data
  });
}

// 文章列表
export function getArticleList(category, page, options) {
  return request.get('/api/document/page', {
    params: {
      category,
      page,
      pageSize: 20,
      ...options
    }
  })
}

// 文章详情
export function getArticleDetail(id) {
  return request.get('/api/document/detail', {
    params: { id }
  });
}

// 赞文章
export function likeArticle(id) {
  return request.post('/api/document/like', { id });
}

// 取消赞文章
export function unlikeArticle(id) {
  return request.post('/api/document/unlike', { id });
}

// 收藏文章
export function collectArticle({ documentId, name, thumbnail }) {
  return request.post('/api/user_more/favorite', {
    documentId,
    name,
    thumbnail
  });
}

// 取消收藏文章
export function uncollectArticle(id) {
  return request.post('/api/user_more/unFavorite', {
    documentId: id
  });
}

// 获取评论列表
export function getCommentList(type, objectId) {
  return request.get('/api/comment/lists', {
    params: {
      type,
      objectId
    }
  })
}

// 发表评论
export function createComment({type, objectId, parentId, content}) {
  return request.post('/api/comment/lists', {
    type,
    objectId,
    parentId,
    content,
  })
}

// 赞评论
export function likeComment(id) {
  return request.post('/api/comment/like', {
    id,
  })
}

// 取消赞评论
export function unlikeComment(id) {
  return request.post('/api/comment/unlike', {
    id,
  })
}

// 文章学习进度
export function updateCourseStudy({id, name, thumbnail}, rate) {
  let course = {
    name,
    thumbnail,
    rate,
    documentId: id,
  }

  return request.post('/api/user_more/study', course).then(() => {
    return course
  })
}

// 微信分享
export function WeChatVoucher(url, api) {
  return request.post('/api/wechat/js_sdk', {
    api,
    url
  })
}

//获取黄金价格
export function getGoldPrice({codes}) {
    return request.post('/api/vendor/jijinhao',{
      codes
    })
}

//改变黄金价格
export function changeGoldPrice({product,cost,isFunc}) {
    return request.post('/api/vendor/update_perfect_gold',{
      product,
      cost,
      isFunc
    })
}

//提交建议
export function submitSuggest(type,content,link) {
  return request.post('/api/suggest/create',{
    type,
    content,
    link
  })
}

//获取品牌列表
export function getBrandList() {
  return request.get('/api/brand/lists')
}

//获取品牌详情
export function getBrandDetail(id) {
  return request.get('/api/brand/detail',{
    params: {
      id
    }
  })
}

//获取品牌商品
export function getBrandGoods(category, brand) {
  return request.get('/api/document/page',{
    params: {
      category,
      page: 1,
      pageSize: 999,
      brand
    }
  })
}

//加v
export function setStatus(userId,level) {
  return request.get('/api/user_more/level',{
    params: {
      userId,
      level
    }
  })
}

//添加二维码
export function setQrcode(qrCode) {
  return request.post('/api/user_more/qrCode',{  
    qrCode
  })
}

//短视频缩略图
export function setVframe({bucket,key,offset,w,h,format}) {
  return request.post('/api/qiniu/vframe', {
    bucket,//gemtec-3d, 默认 gemtec-app-abc,
    key, // 非必须 覆盖时传入
    offset, // 视频第几秒
    w, // 宽度
    h, // 高度
    format, // 格式
  })
}

//状态查询
export function queryStatus(id,type) {
  return request.post('/api/qiniu/status', {
    id,
    type
  }) 
}

//绑定手机
export function bindingMobile({mobile,code,merge}) {
  return request.post('/api/user/binding_mobile', {
    mobile,
    code,
    merge
  })
}

//发送邮件
export function sendMail(to,image) {
  return request.post('/api/mail/anonymous', {
    to,
    image
  })
}